import { useCallback, useState } from 'react';

const STORAGE_KEY = 'cw-theme';

// O atributo data-theme já foi setado pelo script anti-FOUC em
// public/index.html antes do React montar — lemos daqui em vez de
// localStorage pra nunca divergir do que já está pintado na tela.
function lerTemaAtual() {
  return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
}

function useTheme() {
  const [theme, setThemeState] = useState(lerTemaAtual);

  const setTheme = useCallback((novoTema) => {
    document.documentElement.setAttribute('data-theme', novoTema);
    try {
      localStorage.setItem(STORAGE_KEY, novoTema);
    } catch (err) {
      console.error('useTheme: falha ao persistir tema:', err);
    }
    setThemeState(novoTema);
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  }, [theme, setTheme]);

  return { theme, toggleTheme };
}

export default useTheme;
